import { InlineRating, TooltipStars } from 'components/ReviewRating';
import { TRACKING_INTERACTION } from 'contexts/AnalyticsContext/Constants';
import { SEARCH_CARD } from 'lib/constants';
import { CruiseCardShipBase, CruiseCardShipName } from './CruiseCardShip.styles';
import { CruiseCardShipProps } from './CruiseCardShip.types';
import CruiseCardShipIcon from './CruiseCardShipIcon/CruiseCardShipIcon';

function CruiseCardShip({ ship, cruise, showRatings = true }: Readonly<CruiseCardShipProps>) {
	const PARENT_CLASS = 'cruiseCard';

	return (
		<CruiseCardShipBase className={PARENT_CLASS}>
			<CruiseCardShipIcon />
			<CruiseCardShipName data-testid={`cruise-ship-label-${cruise.id}`}>{ship.name}</CruiseCardShipName>
			{showRatings && (
				<TooltipStars
					parentClass={PARENT_CLASS}
					cruise={cruise}
					shipData={ship}
					placement="bottom"
					type={SEARCH_CARD}
					container={TRACKING_INTERACTION.RATING_AND_REVIEW.OPENED_CARD_SEARCH}
				>
					<InlineRating shipCode={ship.code} />
				</TooltipStars>
			)}
		</CruiseCardShipBase>
	);
}

export default CruiseCardShip;
